import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentQuestions: [],
    currentAttempt: null,
};

const examSlice = createSlice({
    name: "exam",
    initialState,
    reducers: {
        setCurrentQuestions: (state, action) => {
            state.currentQuestions = action.payload;
        },
        setCurrentAttempt: (state, action) => {
            state.currentAttempt = action.payload;
        },
    },
});

export const { setCurrentQuestions, setCurrentAttempt } = examSlice.actions;

export const currentQuestions = (state) => state.exam.currentQuestions;
export const currentAttempt = (state) => state.exam.currentAttempt;

export default examSlice.reducer;

